import { doc, setDoc, getDoc, updateDoc, increment, serverTimestamp } from "firebase/firestore";
import { auth, maindb, db } from "../firebaseConfig";
import { createUserWithEmailAndPassword, User, UserCredential } from "firebase/auth";
import { UserDetails } from "../model/UserModel";

export const UserGateway = {
    registerUser: async (email: string, password: string, firstName: string, lastName: string, phoneCode: string, phoneNumber: string) => {
        const userCredential: UserCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        
        const userDocRef = doc(maindb, "users", user.uid); // Reference to the user's document

        await setDoc(userDocRef, {
            firstName,
            lastName,
            phoneNumber,
            phoneCode,
            createdAt: new Date(), // Add a timestamp
            // Add other profile fields as needed
        });

        // Track registration analytics
        try {
            const now = new Date();
            const today = now.toISOString().slice(0, 10);
            const hour = now.getHours();
            
            const registrationsDoc = doc(db, "website", "registrations");
            await setDoc(registrationsDoc, {}, { merge: true });
            await updateDoc(registrationsDoc, {
                totalRegistrations: increment(1),
                lastRegistrationAt: serverTimestamp(),
                [`daily.${today}`]: increment(1),
                [`hourly.${today}.${hour}`]: increment(1)
            });
        } catch (error) {
            console.error("Error recording registration:", error);
        }

        return user.uid;
    },
    GetUser: async (user: User | null ) => {
        if (!user) return null;

        const userRef = doc(maindb, "users", user.uid);
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
            return userSnap.data() as UserDetails;
        }

        return null;
    },
    UpdateUser: async (user: User, userDetails: UserDetails) =>
    {
        return setDoc(doc(maindb, "users", user.uid), { ...userDetails }, { merge: true });
    }
}